module.exports = __webpack_public_path__ + "static/media/CALVI_example.649ac2e6.png";